import { getRandomId } from './utils'
export const CATALOG_MAIN_LINK = 'catalog'
export const CATALOG_ITEM_LINK = 'item'
export const CART_MAIN_LINK = 'cart'
export const SUCCESSFUL_PAYMENT_LINK = 'successful-payment'
export const USER_AGREEMENT_LINK = 'user-agreement'
export const PRIVACY_POLICY_LINK = 'privacy-policy'
export const CONTACT_US_LINK = 'contact-us'
export const STATIC_DOCS_LINK = 'docs'
export const SEARCH_PAGE = 'search'
export const FAVORITE_LINK = 'favorite'
export const FAQ_LINK = 'faq'

export const MAIN_URL = "https://app.sanywatches.com/public";
export const MAIN_URL_SANY = 'https://app.sanywatches.com/sany'
export const INST_URL = 'https://inst-parser.sanywatches.com'
export const LEAD_URL = 'https://tg-function.yc-cabatest.ru/SANY_NOTIFIER'
// export const MAIN_URL = "https://sellone-backend.cabatest.ru/public";

export const DEV_SHOP_ID = "67643c55da6082114a6e3e8a"

export const PHONE = '+7 925 114-50-54'
export const EMAIL = 'neplaneta@gmail.com'
export const ARTICL_NAME = "Артикул"
export const RECENTLY_VIEW_LS_KEY = 'recently-view'
export const OPEN_ITEM_REQUEST = 'item-open-request'
export const POSSIBLE_CONDITION = [
    'Совершенно новый, модель 2024 года',
    'Идеальное состояние',
    'Как новый',
    'Новый, с оригинальной упаковкой',
    'Б/у, в отличном состоянии',
    'Очень хорошее состояние',
    'Хорошее состояние',
    'Слегка использован',
    'С незначительными следами использования',
    'Требуется ремонт',
    'Восстановленный',
    'Лимитированная серия',
    'Коллекционное состояние',
    'Б/у, проверен',
    'Состояние от предыдущего владельца',
    'Упакован для продажи',
    'Сертифицированное состояние',
    'Эксклюзивное состояние',
    'Проверен и гарантирован',
    'Винтажное состояние',
    'Редкий предмет',
    'С использованием, полностью функциональный',
    'С улучшенными компонентами',
    'Без следов использования',
    'Выставочный образец',
    'С оригинальными документами',
    'С дополнительными аксессуарами',
    'Обслужен',
    'С гарантией подлинности',
    'Подлинность проверена',
]

export const CURRENCY_MAP = {
    'USD': '$',  // United States Dollar
    'EUR': '€',  // Euro
    'JPY': '¥',  // Japanese Yen
    'GBP': '£',  // British Pound
    'AUD': 'A$', // Australian Dollar
    'CAD': 'C$', // Canadian Dollar
    'CHF': 'CHF', // Swiss Franc
    'CNY': '¥',  // Chinese Yuan
    'SEK': 'kr',  // Swedish Krona
    'NZD': 'NZ$', // New Zealand Dollar
    'MXN': '$',  // Mexican Peso
    'SGD': 'S$', // Singapore Dollar
    'HKD': 'HK$', // Hong Kong Dollar
    'NOK': 'kr',  // Norwegian Krone
    'KRW': '₩',  // South Korean Won
    'TRY': '₺',  // Turkish Lira
    'INR': '₹',  // Indian Rupee
    'RUB': '₽',  // Russian Ruble
    'BRL': 'R$', // Brazilian Real
    'ZAR': 'R',  // South African Rand
};

export const CURRENCY = [
    'USD',  // United States Dollar
    'USDT',
    'AED',
    'RUB',  // Russian Ruble
    'EUR',  // Euro
    'JPY',  // Japanese Yen
    'GBP',  // British Pound
    'AUD', // Australian Dollar
    'CAD', // Canadian Dollar
    'CHF', // Swiss Franc
    'CNY',  // Chinese Yuan
    'SEK',  // Swedish Krona
    'NZD', // New Zealand Dollar
    'MXN',  // Mexican Peso
    'SGD', // Singapore Dollar
    'HKD', // Hong Kong Dollar
    'NOK',  // Norwegian Krone
    'KRW',  // South Korean Won
    'TRY',  // Turkish Lira
    'INR',  // Indian Rupee
    'BRL', // Brazilian Real
    'ZAR',  // South African Rand
];

export const IMG_PLACEHOLDER_PRODUCT = 'https://app.sanywatches.com/get-file/public/additional_data/product-placeholder.png'
export const IMG_PLACEHOLDER_PROMO = 'https://app.sanywatches.com/get-file/public/additional_data/promo-placeholder.png'
export const LANDING_URL = 'https://sanywatches.com'

export const DEMO_PRODUCT = {
    "_id": "65ac892aca48bfd1dbd637a2",
    "name": "Demo Product",
    "description": "Demo Descript",
    "options": [
        {
            "name": "3",
            "values": [
                {
                    "value": "3",
                    "price_raise": null,
                    "in_stock": null
                },
                {
                    "value": "4",
                    "price_raise": null,
                    "in_stock": null
                }
            ]
        },
        {
            "name": "4",
            "values": [
                {
                    "value": "3",
                    "price_raise": null,
                    "in_stock": null
                }
            ]
        }
    ],
    "price_data": {
        "price": "123323",
        "discount": 2,
        "in_stock": 10
    },
    "categories": [
        {
            "_id": "65ad0632ca48bfd1dbd637d2",
            "name": "new",
            "translit_name": "new-z9qX",
            "count": 1,
            "is_final": true,
            "parents": [
                {
                    "_id": "65ad0632ca48bfd1dbd637d2",
                    "name": "new",
                    "translit_name": "new-z9qX",
                    "count": 1,
                    "is_final": true
                },
                {
                    "_id": "65acfbe4ca48bfd1dbd637ab",
                    "name": "1",
                    "translit_name": "1-cI5U",
                    "count": 8,
                    "is_final": false
                },
                {
                    "_id": "65ac86cbca48bfd1dbd63794",
                    "name": "Диван кровать",
                    "translit_name": "test-4RPc",
                    "count": 4,
                    "is_final": false
                }
            ]
        },
        {
            "_id": "65acfbecca48bfd1dbd637ad",
            "name": "test",
            "translit_name": "test-kS5l",
            "count": 2,
            "is_final": true,
            "parents": [
                {
                    "_id": "65acfbecca48bfd1dbd637ad",
                    "name": "test",
                    "translit_name": "test-kS5l",
                    "count": 2,
                    "is_final": true
                },
                {
                    "_id": "65ac86cbca48bfd1dbd63794",
                    "name": "Диван кровать",
                    "translit_name": "test-4RPc",
                    "count": 4,
                    "is_final": false
                }
            ]
        }
    ],
    "files": [
        {
            "_id": "65acf9d0ca48bfd1dbd637a5",
            "expire_at": null,
            "urls": {
                "orig": IMG_PLACEHOLDER_PRODUCT,
                // "orig": 'https://placehold.co/100x100',

            }
        }
    ]
}




export const ACTIVITY_PING_TIMEOUT = 5000

export const OWN_DELIVERY_TYPE = 'own_delivery'
export const NO_DELIVERY_TYPE = 'no_delivery'
export const NO_DELIVERY_TYPE_2 = 'no_delivery_2'
export const DELIVERY_TYPE_VALUES =
{
    [OWN_DELIVERY_TYPE]: 'Доставка',
    [NO_DELIVERY_TYPE]: 'Самовывоз Дубай',
    [NO_DELIVERY_TYPE_2]: 'Самовывоз РФ',
}

export const WATCHES_CATEGORY_LINK = 'watches'
export const JEWELRY_CATEGORY_LINK = 'jewelry'
export const HERMES_BAGS_CATEGORY_LINK = 'hermes-bags'
export const FINE_ART_CATEGORY_LINK = 'fine-art'
export const ABOUT_US_PAGE_LINK = 'about-us'
export const SELL_TO_US_PAGE_LINK = 'sell-to-us'
export const NEW_CATEGORY_LINK = 'new-arrivals'
export const SPECIAL_CATEGORY_LINK = 'special-offers'

export const ROLEX_CATEGORY_LINK = 'rolex'
export const AUDEMARS_CATEGORY_LINK = 'audemars-piguet'
export const BVLGARY_CATEGORY_LINK = 'bvlgari'
export const CARTIER_CATEGORY_LINK = 'cartier'
export const FRANK_MULLER_CATEGORY_LINK = 'franck-muller'
export const HUBLOT_CATEGORY_LINK = 'hublot'
export const PATEK_PHILIPPE_CATEGORY_LINK = 'patek-philippe'
export const RICHARD_MILE_CATEGORY_LINK = 'richard-mille'
export const FP_JOURNE_CATEGORY_LINK = 'fp-journe'
export const BIRKIN_CATEGORY_LINK = 'birkin'
export const CONSTANCE_CATEGORY_LINK = 'constance'
export const KELLY_CATEGORY_LINK = 'kelly'
export const HERBAG_ZIP_CATEGORY_LINK = 'herbag-zip'
export const EVELYNE_TPM_CATEGORY_LINK = 'evelyne-tpm'
export const HAC_A_DOS_CATEGORY_LINK = 'hac-a-dos'
export const PICOTIN_LOCK_CATEGORY_LINK = 'picotin-lock'
export const BRIDE_A_BRAC_CATEGORY_LINK = 'bride-a-brac'
export const BOLIDE_A_BRAC_CATEGORY_LINK = 'bolide'




export const CONTACT_PHONE = {
    value: '+971542205888',
    formated: '+971 54 220 5888'
}

export const CONTACT_PHONE_2 = {
    value: '+79653338881',
    formated: '+7 965 333-888-1'
}

export const RU_SITE_URL = "https://sanywatches.ru"
// export const RU_SITE_URL = "https://shops-demo.sanywatches.com/store-00000009"
export const EN_SITE_URL = "https://sanywatches.com"
// export const EN_SITE_URL = "https://shops-demo.sanywatches.com/store-00000008"



export const BENEFITES = [
    'Профессиональные оценщики помогают определить справедливую рыночную стоимость',
    'Мгновенные выплаты наличными, криптовалютой или&nbsp;банковским переводом в&nbsp;течение 24&nbsp;часов',
    'Полностью застрахованная доставка и&nbsp;транзакции',
    'Без регистрации — просто введите данные и&nbsp;получите предложение'
]

export const WORKS_STEPS = [
    {
        icon: <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
            <path d="M29.7735 24.594C30.8685 22.644 31.5 20.397 31.5 18C31.5 10.5435 25.4565 4.5 18 4.5C10.5435 4.5 4.5 10.5435 4.5 18C4.5 25.4565 10.5435 31.5 18 31.5C20.397 31.5 22.644 30.8685 24.594 29.7735L31.5 31.5L29.7735 24.594Z" stroke="black" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" />
            <circle cx="17.5" cy="18.5" r="1.5" transform="rotate(-90 17.5 18.5)" fill="black" />
            <circle cx="11.5" cy="18.5" r="1.5" transform="rotate(-90 11.5 18.5)" fill="black" />
            <circle cx="23.5" cy="18.5" r="1.5" transform="rotate(-90 23.5 18.5)" fill="black" />
        </svg>,
        text: `Расскажите нам о вашем предмете`
    },
    {
        icon: <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
            <path d="M18 31.5H7.5C6.70435 31.5 5.94129 31.1839 5.37868 30.6213C4.81607 30.0587 4.5 29.2956 4.5 28.5V7.5C4.5 6.70435 4.81607 5.94129 5.37868 5.37868C5.94129 4.81607 6.70435 4.5 7.5 4.5H28.5C29.2956 4.5 30.0587 4.81607 30.6213 5.37868C31.1839 5.94129 31.5 6.70435 31.5 7.5V18" stroke="black" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M18 24H10.5" stroke="black" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M25.5 18H10.5" stroke="black" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M25.5 12H10.5" stroke="black" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M27 24V30" stroke="black" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M30 27H24" stroke="black" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
        text: `Добавьте размеры, историю
        и документы`
    },
    {
        icon: <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
            <path d="M31.5 16.5V24C31.5 28.1421 28.1421 31.5 24 31.5H12C7.85787 31.5 4.5 28.1421 4.5 24V12C4.5 7.85787 7.85787 4.5 12 4.5H19.5" stroke="black" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M21.8206 14.181C23.9291 16.2902 23.9285 19.7093 21.8193 21.8178C19.7101 23.9263 16.291 23.9257 14.1826 21.8165C12.0746 19.7078 12.0746 16.2897 14.1826 14.181C16.291 12.0718 19.7101 12.0713 21.8193 14.1798C21.8197 14.1802 21.8201 14.1806 21.8206 14.181Z" stroke="black" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M25.5 6.75H33" stroke="black" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M29.25 10.5V3" stroke="black" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
        text: `Загрузите фотографии`
    },
    {
        icon: <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
            <path d="M4.5 18.3795C4.5 22.107 10.5435 25.1295 18 25.1295" stroke="black" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M31.5 18.3795C31.5 20.7195 29.1165 22.7805 25.5 23.991" stroke="black" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M19.5 25.1295H18C10.5435 25.1295 4.5 22.107 4.5 18.3795" stroke="black" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M16.1328 28.497L19.5018 25.1295L16.1328 21.7605" stroke="black" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M31.5 18.3795C31.5 15.4425 27.7395 12.9525 22.5 12.0255" stroke="black" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" />
            <circle cx="18" cy="11.6249" r="1.5" fill="black" />
            <circle cx="18" cy="6.49994" r="1.5" fill="black" />
            <circle cx="18" cy="16.4999" r="1.5" fill="black" />
            <path d="M13.5 12.024C8.2605 12.951 4.5 15.441 4.5 18.378" stroke="black" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
        text: `Снимите переднюю и заднюю
        стороны предмета`
    },
    {
        icon: <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
            <path d="M25.5 13.5L19.1952 16.2498C18.8169 16.4148 18.4086 16.5 17.9959 16.5C17.5832 16.5 17.1749 16.4148 16.7966 16.2498L10.5 13.5036" stroke="black" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M18 28.5H25.5C27.0913 28.5 28.6174 27.8679 29.7426 26.7426C30.8679 25.6174 31.5 24.0913 31.5 22.5V12C31.5 10.4087 30.8679 8.88258 29.7426 7.75736C28.6174 6.63214 27.0913 6 25.5 6H10.5C8.9087 6 7.38258 6.63214 6.25736 7.75736C5.13214 8.88258 4.5 10.4087 4.5 12V17.25" stroke="black" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M4.5 24.7499H12" stroke="black" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M9 21.75L12 24.75L9 27.75" stroke="black" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
        text: `Проверьте и отправьте`
    },
    {
        icon: <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
            <path d="M12.9727 13.6647V9.42203" stroke="black" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M15.0942 11.5433H10.8516" stroke="black" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M24.0008 23.895L18.3008 18.15" stroke="black" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M12.9714 20.0147C17.65 20.0147 21.4427 16.2219 21.4427 11.5433C21.4427 6.86475 17.65 3.07199 12.9714 3.07199C8.29275 3.07199 4.5 6.86475 4.5 11.5433C4.5 16.2219 8.29275 20.0147 12.9714 20.0147Z" stroke="black" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M19.372 6H25.5C28.8137 6 31.5 8.68629 31.5 12V25.5C31.5 28.8137 28.8137 31.5 25.5 31.5H12C8.68629 31.5 6 28.8137 6 25.5V16.3552" stroke="black" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
        text: `Готово! Наши специалисты
        проверят вашу заявку`
    },
];

export const TYPES = [
    {
        title: 'Часы',
        formated: 'watches'
    },
    {
        title: 'Ювелирные изделия',
        formated: 'jewelry'
    },
    {
        title: 'Сумки Hermès',
        formated: 'hermes'
    },
    // {
    //     title: 'Искусство',
    //     formated: 'fine_art'
    // },
    {
        title: 'Другое',
        formated: 'other'
    }
];

export const TELEGRAM_CONTACT_LINK = "https://t.me/sanywatch"
export const WHATSAPP_CONTACT_LINK = "https://wa.me/971564371818"

export const QUESTIONS = [
    {
        _id: getRandomId(),
        question: "Кто такие Sany Watches?",
        answer: "Sany Watches&nbsp;— это компания, занимающаяся продажей роскошных часов в&nbsp;Дубае и&nbsp;Москве. Она основана увлечённым предпринимателем, чья семья имеет богатый опыт в&nbsp;ювелирном и часовом деле. Мы&nbsp;специализируемся на&nbsp;поиске и&nbsp;продаже <b>качественных, подлинных часов премиум-класса от&nbsp;ведущих мировых брендов.</b>",
    },
    {
        _id: getRandomId(),
        question: "Являются ли ваши часы на&nbsp;100% подлинными?",
        answer: "<b>Разумеется!</b> Каждая модель поступает от&nbsp;надежных поставщиков или официальных дилеров. Мы&nbsp;всегда проверяем часы, чтобы убедиться в&nbsp;их&nbsp;подлинности и&nbsp;соответствии высоким стандартам качества.",
    },
    {
        _id: getRandomId(),
        question: "Какие типы часов вы&nbsp;предлагаете?",
        answer: "Мы&nbsp;предлагаем широкий выбор роскошных часов: новые, ранее использованные и&nbsp;винтажные модели. В&nbsp;нашем ассортименте можно найти <b>Rolex</b>, <b>Patek&nbsp;Philippe</b>, <b>Audemars&nbsp;Piguet</b>, <b>Richard Mille</b> и&nbsp;другие престижные марки, подобранные как для новичков, так и&nbsp;для опытных коллекционеров.",
    },
    {
        _id: getRandomId(),
        question: "Почему ваши цены ниже, чем в&nbsp;других магазинах?",
        answer: "Мы&nbsp;сотрудничаем напрямую с&nbsp;производителями и&nbsp;надежными поставщиками, оптимизируем расходы на&nbsp;логистику и&nbsp;складирование, а&nbsp;также закупаем часы крупными партиями. Благодаря этому мы&nbsp;можем предлагать роскошные модели по&nbsp;доступной цене.",
    },
    {
        _id: getRandomId(),
        question: "Как можно купить часы у&nbsp;Sany Watches?",
        answer: "Ознакомьтесь с&nbsp;нашим онлайн-каталогом или свяжитесь с&nbsp;нами напрямую для индивидуальной консультации. Мы&nbsp;предлагаем удобные способы оплаты, доставку по&nbsp;всему миру и&nbsp;VIP-консультации для эксклюзивных моделей&nbsp;— всё это обеспечивает легкий и&nbsp;комфортный процесс покупки.",
    },
    {
        _id: getRandomId(),
        question: "Доставляете ли вы&nbsp;часы по&nbsp;всему миру?",
        answer: "<b>Да.</b> Мы&nbsp;отправляем заказы в&nbsp;любую точку мира из&nbsp;Дубая и&nbsp;Москвы, используя проверенные и&nbsp;застрахованные способы доставки, чтобы часы прибыли к&nbsp;вам целыми и&nbsp;вовремя.",
    },
    {
        _id: getRandomId(),
        question: "Поставляются ли часы с&nbsp;оригинальной коробкой и&nbsp;документами?",
        answer: "Где это возможно, мы&nbsp;передаём оригинальную коробку, документы и&nbsp;аксессуары. Для часов с&nbsp;пробегом (ранее использованных) комплект может отличаться; мы&nbsp;всегда уточняем, если предоставляется полный набор.",
    },
    {
        _id: getRandomId(),
        question: "Предоставляете ли вы&nbsp;гарантию на&nbsp;часы?",
        answer: "<b>Да.</b> Новые часы идут с&nbsp;заводской гарантией производителя, а&nbsp;для ранее использованных может действовать гарантия нашего магазина. Каждая модель проходит детальный осмотр и&nbsp;сервисную проверку перед продажей.",
    },
    {
        _id: getRandomId(),
        question: "Как вы&nbsp;проверяете подлинность ранее использованных часов?",
        answer: "Мы&nbsp;проводим комплексную проверку: осматриваем механизмы и&nbsp;корпус, сверяем заводские номера с&nbsp;официальными базами и&nbsp;привлекаем экспертов. Только после этого часы выставляются на&nbsp;продажу.",
    },
    {
        _id: getRandomId(),
        question: "Какие способы оплаты принимаются?",
        answer: "Мы&nbsp;принимаем платежи банковскими картами, переводы со&nbsp;счёта на&nbsp;счёт, а&nbsp;также в&nbsp;отдельных случаях PayPal и&nbsp;криптовалюту. Выберите наиболее удобный для вас вариант оплаты.",
    },
    {
        _id: getRandomId(),
        question: "Можно ли&nbsp;купить часы в&nbsp;рассрочку?",
        answer: "<b>Да,</b> у&nbsp;нас есть партнёры, предлагающие гибкие условия финансирования. Вы&nbsp;сможете оплатить покупку в&nbsp;несколько платежей, однако точные условия зависят от&nbsp;вашего региона и&nbsp;результатов кредитной проверки.",
    },
    {
        _id: getRandomId(),
        question: "Скупаете ли&nbsp;вы&nbsp;часы у&nbsp;частных лиц?",
        answer: "<b>Да,</b> мы&nbsp;можем приобрести некоторые модели у&nbsp;частных продавцов. Мы&nbsp;оценим часы, учитывая их&nbsp;состояние, популярность и&nbsp;рыночную стоимость, а&nbsp;затем предложим справедливую цену.",
    },
    {
        _id: getRandomId(),
        question: "Можно ли&nbsp;обменять свои часы на&nbsp;другую модель?",
        answer: "<b>Безусловно.</b> Мы&nbsp;предлагаем услугу трейд-ин, которая позволяет заменить ваши текущие часы на&nbsp;другую модель. После оценки стоимости ваших часов мы&nbsp;проговорим все варианты, чтобы вы&nbsp;остались довольны.",
    },
    {
        _id: getRandomId(),
        question: "Сколько обычно занимает доставка?",
        answer: "Это зависит от&nbsp;региона. При наличии товара на&nbsp;складе внутри страны доставка обычно занимает 1–3&nbsp;рабочих дня, а&nbsp;за&nbsp;рубеж&nbsp;— 5–10&nbsp;дней. Мы&nbsp;предоставляем номер для отслеживания посылки, чтобы вы&nbsp;всегда знали, где находится ваша покупка.",
    },
    {
        _id: getRandomId(),
        question: "Страхуется ли&nbsp;посылка во&nbsp;время доставки?",
        answer: "<b>Да,</b> каждая отправка полностью застрахована. Это даёт вам уверенность в&nbsp;том, что при любых форс-мажорах ваши инвестиции будут защищены.",
    },
    {
        _id: getRandomId(),
        question: "Можно ли&nbsp;заказать индивидуальную кастомизацию часов?",
        answer: "<b>Да.</b> Мы&nbsp;можем помочь с&nbsp;заменой ремешка, гравировкой или небольшими изменениями в&nbsp;дизайне. Для более сложных работ, таких как инкрустация бриллиантами, мы&nbsp;сотрудничаем с&nbsp;проверенными специалистами, чтобы сохранить высокое качество исполнения.",
    },
];

export const Y_MAP_API_KEY = '8f7dff30-8c1b-4f02-b103-44eeca43e8b6'

export const APPSTORE_APP_LINK = 'https://apps.apple.com/us/app/sany/id6748041729'
export const PLAYMARKET_APP_LINK = 'https://play.google.com/store/apps/details?id=com.sanywatches.app'